import React from 'react';
import { useGame } from '../../context/GameContext';
import './TurnManagement.css';

const EraComplete = () => {
  const { 
    gameState, 
    currentEra,
    readyForNextEra,
    handleReadyForNextEra
  } = useGame();

  // Only show this component when game state is era_complete
  if (gameState !== 'era_complete') {
    return null;
  }

  return (
    <div className="turn-management-section">
      <div className="era-complete-section">
        <h3>Era {currentEra} Complete!</h3>
        <p>All words have been created for this era.</p>
        {!readyForNextEra ? (
          <button className="ready-btn" onClick={handleReadyForNextEra}>
            Ready for Next Era
          </button>
        ) : (
          <p className="waiting-text">Waiting for other players to be ready...</p>
        )}
      </div>
    </div>
  );
};

export default EraComplete; 